import { AfterViewInit, Component, Input } from '@angular/core';
import { ImageQuestionV3 } from '../../../classes/question-image';
import { QuestionBaseV3ComponentDirective } from '../question-base.component';

@Component({
  selector: 'bepatient-input-image-v3',
  templateUrl: './input-image.component.html',
  styleUrls: ['./input-image.component.scss'],
  standalone: false
})
export class InputImageComponentV3
  extends QuestionBaseV3ComponentDirective
  implements AfterViewInit
{
  @Input() question: ImageQuestionV3;
  @Input() color: string;

  spinner: HTMLElement;

  ngAfterViewInit(): void {
    /**
     * Getting image width/height if exist in css
     * */
    const img = document.getElementById('image-src');
    if (this.question.css && this.question.css.width) {
      const widthMatch = this.question.css.width.match(/(\d+)/);
      const screenWidth = window.innerWidth;
      // If screen width is greater than image width set width & height
      if (img && widthMatch && screenWidth > Number(widthMatch[0])) {
        img.style.width = this.question.css.width;
        if (this.question.css.height) {
          img.style.height = this.question.css.height;
        }
      }
    }
    // Adding spinner
    this.spinner = document.createElement('ion-spinner');
    this.spinner.setAttribute('name', 'dots');
    this.spinner.style.alignSelf = 'center';
    this.spinner.style.top = '16px';
    const frame = document.getElementById('input-image-content');
    frame.prepend(this.spinner);

    if (!img) {
      this.spinner.remove();
    } else {
      img.addEventListener('load', () => {
        this.spinner.remove();
      });
      img.addEventListener('fail', () => {
        this.spinner.remove();
      });
    }
  }
}
